import { useAppSelector } from "./useAppSelector";

export function usePermissions() {
    const token = useAppSelector(s => s.session.user.token);
    let invis: string[] = token?.userInvisibleActions ?? [];
    let disab: string[] = token?.userDisabledActions ?? [];
    return invis.concat(disab);
}
